import { render } from "./myWelFare.vue?vue&type=template&id=795fa5b5"
import script from "./myWelFare.vue?vue&type=script&lang=js"
export * from "./myWelFare.vue?vue&type=script&lang=js"

import "./myWelFare.vue?vue&type=style&index=0&id=795fa5b5&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__